import {
    Box,
    Link,
    Stack,
    Typography
} from '@mui/material';

export default function CaktoApiDocHeader() {
    return (
        <Stack spacing={1}>
            <Box>
                <Typography variant="h4">
                    Cakto API
                </Typography>
            </Box>

            <Box sx={{
                p: 3,
                borderRadius: 2,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                border: (theme) => `1px solid ${theme.palette.divider}`,
                backgroundImage: 'url(/assets/images/dashboard/cakto-api/binaryCodeBanner.png)',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                position: 'relative',
                '&::before': {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: (theme) => theme.palette.mode === 'light'
                        ? 'rgba(255, 255, 255, 0.01)'
                        : 'rgba(33, 43, 54, 0.3)',          // #212B36 com opacidade  
                    borderRadius: 2,
                    zIndex: 1,
                },
                '& > *': {
                    position: 'relative',
                    zIndex: 2,
                }
            }}>
                <Box>
                    <Typography variant="h6" sx={{ color: 'text.primary' }}>
                        Documentação
                    </Typography>
                    <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                        <Link
                            target="_blank"
                            rel="noopener noreferrer"
                            href='https://docs.cakto.com.br/'
                            sx={{ color: 'success.main', textDecoration: 'underline' }}
                        >
                            Clique aqui
                        </Link> e acesse toda a nossa documentação
                    </Typography>
                </Box>

                <Box>
                    <img src='/logo/green-cakto-logo.png' alt='Cakto' />
                </Box>
            </Box>
        </Stack>
    )
}